export const getPricingPageURL = (locale: string) => {
  const pricingPageEndpoint = locale === 'en' ? 'pricing' : `${locale}/pricing`

  return `${process.env.NEXT_PUBLIC_WEBSITE_MARKETING_URL}/${pricingPageEndpoint}`
}
